/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Const } from "const";
import { useTaskRegisterDataContext } from "context/TaskRegisterDataProvider";
import { formatDate } from "utils/DateTime";

export const useJobName = () => {
  const { materials } = useTaskRegisterDataContext();
  return (
    materialId: number | undefined,
    requestedEndDateTime: Date | null | undefined
  ) => {
    const materialName =
      materials?.find((material) => material.type === materialId)?.name ?? "-";
    const requestedEndDateTimeString = requestedEndDateTime
      ? formatDate(requestedEndDateTime, Const.dateTimeFormat)
      : "";
    return `${materialName}-${requestedEndDateTimeString}`;
  };
};
